import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=1536bad8&scoped=true"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=1536bad8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536bad8",
  null
  
)

export default component.exports